/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { observer } from 'mobx-react';
import { Box, DialogContent, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { ModuleDetailViewUseStyles } from '../ModuleDetailViewStyles';
import { Image } from '../../../../../../types/elements/Image';

interface Props {
	moduleImage?: Image;
	moduleName: string;
	moduleDescription: string;
	setShowDetailImage: () => void;
}

export const ModuleDetailDataView = observer((props: Props) => {
	const { classes } = ModuleDetailViewUseStyles();
	const { moduleImage, moduleName, moduleDescription, setShowDetailImage } = props;

	return (
		<DialogContent className={classes.content} classes={{ root: classes.contentRoot }}>
			<Box className={classes.textContainer}>
				<Typography variant='h2' className={classes.subTitle}>
					<FormattedMessage id={'modules.module_detail.name'} />
				</Typography>
				<Typography className={classes.text}>{moduleName}</Typography>
			</Box>
			<Typography variant='h2' className={classes.subTitle}>
				<FormattedMessage id={'modules.module_detail.description'} />
			</Typography>
			<Typography className={classes.text}>{moduleDescription}</Typography>
			{!!moduleImage && (
				<img
					src={moduleImage.src}
					alt={moduleImage.alt}
					className={classes.image}
					onClick={() => setShowDetailImage()}
				/>
			)}
		</DialogContent>
	);
});
